import React, { memo } from 'react';
import {View, StyleSheet, Text } from 'react-native';
import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';
import { Dropdown } from 'react-native-element-dropdown';

import Icon from '../../UI/icon/Icon';
import { ICON_SIZE } from '../../../constants/UIConstants';
import commonStyles from '../../UI/styles/common';
import navbar from '../../UI/styles/navbar';

const CanvasMenu = (props) => (
	<View style={styles.menuContainer}>
		<View style={styles.iconContainer}>
			{!props.isHideMenu && <Dropdown
				style={styles.dropdownContainer}
				placeholderStyle={commonStyles.zeroDimensions}
				// If you use selectedTextStyles to pass this value, applies to selected text and dropdown text
				selectedTextProps={{
					style: commonStyles.zeroDimensions,
				}}
				inputSearchStyle={commonStyles.zeroDimensions}
				iconStyle={commonStyles.zeroDimensions}
				containerStyle={styles.dropdownDrawerContainer}
				labelField="label"
				valueField="value"
				data={props.items.map((item) => ({
					...item,
					action: () => props.onPress(item.value),
				}))}
				onChange={(item) => item.action()}
				renderItem={(props) => (
					<View style={styles.dropdownRowContainer}>
						<View style={styles.dropdownIconContainer}>
							<Icon
								icon={props.icon}
								size={(props.iconSize) ? props.iconSize : ICON_SIZE.md}
								color={(props.iconColor) ? props.iconColor : COLORS.dark}
							/>
						</View>
						<Text
							numberOfLines={1}
							style={styles.dropdownItemText}>
							{props.label}
						</Text>
					</View>
				)}
				renderLeftIcon={() => (
					<View style={styles.menuIcon}>
						<Icon
							icon={props.icon}
							size={ICON_SIZE.lg}
							color={COLORS.dark}
						/>
					</View>
				)}
			/>}
		</View>
		<View style={styles.textContainer}>
			{props.text && <Text
				numberOfLines={1}
				style={{
					...styles.buttonText,
					color: (props.color) ? props.color : COLORS.dark
				}}
			>
				{props.text}
			</Text>}
		</View>
	</View>
);

const styles = StyleSheet.create({
	iconContainer: {
		flex: 1,
		width: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	textContainer: {
		height: 20,
		justifyContent: 'center',
		alignItems: 'center',
	},
	buttonText: {
		color: COLORS.dark,
		fontFamily: FONTS.default,
		fontSize: FONT_SIZES.xs,
	},
	menuContainer: {
		justifyContent: 'center',
		alignItems: 'center',
		width: 80,
		height: navbar.height,
	},
	dropdownContainer: {
		alignItems: 'center',
	},
	dropdownDrawerContainer: {
		width: 120,
	},
	dropdownRowContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: COLORS.offWhite,
	},
	dropdownIconContainer: {
		justifyContent: 'center',
		alignItems: 'center',
		width: 28,
		height: 26,
		margin: 5,
	},
	dropdownItemText: {
		fontFamily: FONTS.default,
		fontSize: FONT_SIZES.lg,
	},
});

export default memo(CanvasMenu);